import type { ProntuarioPastSessionRecord } from '../types/prontuarioPastSession';

/**
 * Resumo exibido no card da lista — prioriza `resumo`; fallback para evolução.
 */
export const resolveProntuarioPastSessionSummary = (
	record: ProntuarioPastSessionRecord,
): string | null => {
	const resumoCurto = record.resumoCurto?.trim();
	if (resumoCurto) return resumoCurto;

	const resumo = record.resumo?.trim();
	if (resumo) return resumo;

	const evolucao = record.evolucaoObservacoes?.trim();
	if (evolucao) return evolucao;

	return null;
};
